import type { PickActions } from '@core/ngrx-legacy';
import { createSingleEntityStore } from '@core/ngrx-legacy';

import type { CandidateCounters } from './candidate-counters-http-client';

const { actions, reducer, selectors, namespace } =
  createSingleEntityStore<CandidateCounters>()('CandidateCounters');

const CandidateCountersActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  CandidateCountersActions,
  reducer as CandidateCountersReducer,
  selectors as CandidateCountersSelectors,
  namespace as CandidateCountersNamespace,
};
